import { theme } from '@energiebespaarders/symbols';
import { IconContext } from '@phosphor-icons/react';
import React, { useCallback, useState } from 'react';
import Headroom from 'react-headroom';
import useMediaQuery from '~/hooks/useMediaQuery';
import MobileNav from './MobileNav';
import Navbar from './Navbar';

const Navigation: React.FC = () => {
  const [sidebarNavOpen, setSidebarNavOpen] = useState(false);
  const isTabletOrSmaller = useMediaQuery('lg');
  const toggleSidebarNav = useCallback(() => setSidebarNavOpen(!sidebarNavOpen), [sidebarNavOpen]);
  return (
    <header id="top">
      <IconContext.Provider
        value={{
          size: '1em',
          weight: 'duotone',
          style: { verticalAlign: 'text-bottom', marginRight: 6 },
        }}
      >
        {isTabletOrSmaller && (
          <MobileNav toggleSidebarNav={toggleSidebarNav} isOpen={sidebarNavOpen} />
        )}
        <Headroom wrapperStyle={{ position: 'relative', zIndex: theme.z.nav }}>
          <Navbar toggleSidebarNav={toggleSidebarNav} sidebarNavOpen={sidebarNavOpen} />
        </Headroom>
      </IconContext.Provider>
    </header>
  );
};

export default Navigation;
